import { render, staticRenderFns } from "./Component-InfoPanel.vue?vue&type=template&id=136558a2"
import script from "./Component-InfoPanel.vue?vue&type=script&lang=js"
export * from "./Component-InfoPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports